import type { ComponentType, PropsWithChildren } from 'react';
import type React from 'react';

import { TrackingContext } from '@change-corgi/core/react/tracking';

import type { ErrorStateDetails } from 'src/app/shared/utils/async';
import { isError, isLoaded } from 'src/app/shared/utils/async';

import type { ImpactStoryPageCombinedState, ImpactStoryPagePrefetchedContext } from './hook';
import { usePageContext } from './hook';
import { ImpactStoryPageDataContextProvider } from './pageData';

export type ErrorHandlerProps = { context: ErrorStateDetails<ImpactStoryPageCombinedState> };

type Props = {
	slug: string;
	prefetchedData: ImpactStoryPagePrefetchedContext | undefined;
	errorHandler: ComponentType<ErrorHandlerProps>;
	loadingFallback: JSX.Element;
};

export const ImpactStoryPageContextProvider: React.FC<PropsWithChildren<Props>> = ({
	children,
	slug,
	prefetchedData,
	errorHandler: ErrorHandler,
	loadingFallback,
}) => {
	const pageContextState = usePageContext(slug, prefetchedData);

	if (isError(pageContextState)) {
		const { status, ...rest } = pageContextState;
		return <ErrorHandler context={rest} />;
	}
	if (!isLoaded(pageContextState)) return loadingFallback;

	const { pageData } = pageContextState;

	return (
		<ImpactStoryPageDataContextProvider pageData={pageData}>
			<TrackingContext properties={{ petition_id: pageData.data.petition.id }}>{children}</TrackingContext>
		</ImpactStoryPageDataContextProvider>
	);
};
